"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignSystemThemeColor = exports.DesignSystemColor = void 0;
var Gray;
(function (Gray) {
    Gray["LIGHT_6"] = "#F9F9FA";
    Gray["LIGHT_5"] = "#F5F6F7";
    Gray["LIGHT_4"] = "#F0F1F2";
    Gray["LIGHT_3"] = "#E2E4E7";
    Gray["LIGHT_2"] = "#CDD1D5";
    Gray["LIGHT_1"] = "#99A0AA";
    Gray["DEFAULT"] = "#696F7B";
    Gray["DARK_1"] = "#4B555E";
    Gray["DARK_2"] = "#38414E";
    Gray["DARK_3"] = "#1F2936";
    Gray["DARK_4"] = "#101825";
    /**
     * @deprecated
     */
    Gray["DARK_5"] = "#101825";
})(Gray || (Gray = {}));
var Blue;
(function (Blue) {
    Blue["LIGHT_6"] = "#EDFAFE";
    Blue["LIGHT_5"] = "#E5F7FE";
    Blue["LIGHT_4"] = "#CCF0FD";
    Blue["LIGHT_3"] = "#99DEF7";
    Blue["LIGHT_2"] = "#40B6E8";
    Blue["LIGHT_1"] = "#0D96D5";
    Blue["DEFAULT"] = "#007BC1";
    Blue["DARK_1"] = "#0069A4";
    Blue["DARK_2"] = "#005687";
    Blue["DARK_3"] = "#004770";
    Blue["DARK_4"] = "#003B5C";
    /**
     * @deprecated
     */
    Blue["DARK_5"] = "#003B5C";
})(Blue || (Blue = {}));
var Red;
(function (Red) {
    Red["LIGHT_6"] = "#FFFBFA";
    Red["LIGHT_5"] = "#FEF3F2";
    Red["LIGHT_4"] = "#FEE4E2";
    Red["LIGHT_3"] = "#FECDCA";
    Red["LIGHT_2"] = "#FDA29B";
    Red["LIGHT_1"] = "#F97066";
    Red["DEFAULT"] = "#F04438";
    Red["DARK_1"] = "#D92D20";
    Red["DARK_2"] = "#B42318";
    Red["DARK_3"] = "#912018";
    Red["DARK_4"] = "#7A271A";
    /**
     * @deprecated
     */
    Red["DARK_5"] = "#7A271A";
})(Red || (Red = {}));
var Yellow;
(function (Yellow) {
    Yellow["LIGHT_6"] = "#FEFDF0";
    Yellow["LIGHT_5"] = "#FEFBE8";
    Yellow["LIGHT_4"] = "#FEF7C3";
    Yellow["LIGHT_3"] = "#FEEE95";
    Yellow["LIGHT_2"] = "#FDE272";
    Yellow["LIGHT_1"] = "#FAC515";
    Yellow["DEFAULT"] = "#EAAA08";
    Yellow["DARK_1"] = "#CA8504";
    Yellow["DARK_2"] = "#A15C07";
    Yellow["DARK_3"] = "#854A0E";
    Yellow["DARK_4"] = "#713B12";
    /**
     * @deprecated
     */
    Yellow["DARK_5"] = "#713B12";
})(Yellow || (Yellow = {}));
var Green;
(function (Green) {
    Green["LIGHT_6"] = "#F6FEF9";
    Green["LIGHT_5"] = "#ECFDF3";
    Green["LIGHT_4"] = "#D1FADF";
    Green["LIGHT_3"] = "#A6F4C5";
    Green["LIGHT_2"] = "#6CE9A6";
    Green["LIGHT_1"] = "#32D583";
    Green["DEFAULT"] = "#12B76A";
    Green["DARK_1"] = "#039855";
    Green["DARK_2"] = "#027A48";
    Green["DARK_3"] = "#05603A";
    Green["DARK_4"] = "#054F31";
    /**
     * @deprecated
     */
    Green["DARK_5"] = "#054F31";
})(Green || (Green = {}));
var Orange;
(function (Orange) {
    Orange["LIGHT_6"] = "#FEFAF5";
    Orange["LIGHT_5"] = "#FEF6EE";
    Orange["LIGHT_4"] = "#FDEAD7";
    Orange["LIGHT_3"] = "#F9DBAF";
    Orange["LIGHT_2"] = "#F7B27A";
    Orange["LIGHT_1"] = "#F38744";
    Orange["DEFAULT"] = "#EF6820";
    Orange["DARK_1"] = "#E04F16";
    Orange["DARK_2"] = "#B93815";
    Orange["DARK_3"] = "#932F19";
    Orange["DARK_4"] = "#772917";
    /**
     * @deprecated
     */
    Orange["DARK_5"] = "#772917";
})(Orange || (Orange = {}));
var Pink;
(function (Pink) {
    Pink["LIGHT_6"] = "#FEF6FB";
    Pink["LIGHT_5"] = "#FDF2FA";
    Pink["LIGHT_4"] = "#FCE7F6";
    Pink["LIGHT_3"] = "#FCCEEE";
    Pink["LIGHT_2"] = "#FAA7E0";
    Pink["LIGHT_1"] = "#F670C7";
    Pink["DEFAULT"] = "#EE46BC";
    Pink["DARK_1"] = "#DD2590";
    Pink["DARK_2"] = "#C11574";
    Pink["DARK_3"] = "#9E165F";
    Pink["DARK_4"] = "#851651";
    /**
     * @deprecated
     */
    Pink["DARK_5"] = "#851651";
})(Pink || (Pink = {}));
var Violet;
(function (Violet) {
    Violet["LIGHT_6"] = "#FBFAFF";
    Violet["LIGHT_5"] = "#F5F3FF";
    Violet["LIGHT_4"] = "#ECE9FE";
    Violet["LIGHT_3"] = "#DDD6FE";
    Violet["LIGHT_2"] = "#C3B5FD";
    Violet["LIGHT_1"] = "#A48AFB";
    Violet["DEFAULT"] = "#875BF7";
    Violet["DARK_1"] = "#7839EE";
    Violet["DARK_2"] = "#6927DA";
    Violet["DARK_3"] = "#5720B7";
    Violet["DARK_4"] = "#491C96";
    /**
     * @deprecated
     */
    Violet["DARK_5"] = "#491C96";
})(Violet || (Violet = {}));
var Teal;
(function (Teal) {
    Teal["LIGHT_6"] = "#EAFAFA";
    Teal["LIGHT_5"] = "#D2F4F3";
    Teal["LIGHT_4"] = "#B5EEEC";
    Teal["LIGHT_3"] = "#83E2DF";
    Teal["LIGHT_2"] = "#43D6D1";
    Teal["LIGHT_1"] = "#19CCC6";
    Teal["DEFAULT"] = "#00B3B0";
    Teal["DARK_1"] = "#008A87";
    Teal["DARK_2"] = "#007573";
    Teal["DARK_3"] = "#005C5A";
    Teal["DARK_4"] = "#004947";
    /**
     * @deprecated
     */
    Teal["DARK_5"] = "#004947";
})(Teal || (Teal = {}));
var White;
(function (White) {
    White["DEFAULT"] = "#FFFFFF";
})(White || (White = {}));
var Black;
(function (Black) {
    Black["DEFAULT"] = "#000000";
})(Black || (Black = {}));
exports.DesignSystemColor = {
    Gray: Gray,
    Blue: Blue,
    Red: Red,
    Yellow: Yellow,
    Green: Green,
    Orange: Orange,
    Pink: Pink,
    Violet: Violet,
    Teal: Teal,
    White: White,
    Black: Black,
};
exports.DesignSystemThemeColor = {
    Gray: exports.DesignSystemColor.Gray,
    Primary: exports.DesignSystemColor.Blue,
    Error: exports.DesignSystemColor.Red,
    Warning: exports.DesignSystemColor.Yellow,
    Success: exports.DesignSystemColor.Green,
};
